// ReusableBox.js
import React from 'react';
import MuiBox from '@mui/material/Box';

function Box({ children, ...restProps }) {
  return <MuiBox {...restProps}>{children}</MuiBox>;
}

export default Box;
